import { tawlaAuthReturnPath, tawlaRegistrationAgentRid } from "./TawlaRoomInvite";
import { holdemAuthReturnPath, holdemRegistrationAgentRid } from "./HoldemRoomInvite";
import { tarneebAuthReturnPath, tarneebRegistrationAgentRid } from "./TarneebRoomInvite";

export function roomInviteAuthReturnPath(backTo) {
  return tawlaAuthReturnPath(backTo) || holdemAuthReturnPath(backTo) || tarneebAuthReturnPath(backTo);
}

export function roomInviteRegistrationAgentRid(backTo, storedAgentRid) {
  return tarneebRegistrationAgentRid(backTo,
    holdemRegistrationAgentRid(backTo, tawlaRegistrationAgentRid(backTo, storedAgentRid)));
}
